export const defaultLocales = ['en', 'pt-BR', 'fr'];

const locales = {
  en: {
    i18n: {
      title: 'i18next',
      typograph: 'Typograph test',
      date: '{{val, datetime}}',
      money: '{{val, currency(USD)}}',
      value: '{{val, number}}',
      yes: 'Yes',
      no: 'No',
    },
  },
  fr: {
    i18n: {
      title: 'i18next',
      typograph: 'Teste tipografia french',
      date: '{{val, datetime}}',
      money: '{{val, currency(USD)}}',
      value: '{{val, number}}',
      yes: 'oui',
      no: 'non',
    },
  },
  'pt-BR': {
    i18n: {
      title: 'i18next',
      typograph: 'Teste tipografia',
      date: '{{val, datetime}}',
      money: '{{val, currency(USD)}}',
      value: '{{val, number}}',
      yes: 'sim',
      no: 'não',
    },
  },
};

export default locales;
